export var DEPLOY_DATE = new Date('2026-01-15T09:01:40+0000');
